import { z } from 'zod';
import { UserRole } from '../constants/session.constants';

export const TranscriptionResultSchema = z.object({
  id: z.string().optional(),
  sessionId: z.string(),
  role: z.nativeEnum(UserRole).optional(),
  originalText: z.string(),
  detectedLanguage: z.string().default('es'),
  languageProbability: z.number().optional(),
  translatedText: z.string().optional(),
  targetLanguage: z.string().optional(),
  processingTimeMs: z.number().optional(),
  timestamp: z.number()
});

export type TranscriptionResult = z.infer<typeof TranscriptionResultSchema>;
